export default __webpack_public_path__ + "images/menu-hover-arrow.svg";